import { DEFAULT_WORKSPACE_HEIGHT, entitreeSettings, MapNode } from 'components/MapComponents';
import { layoutFromMap } from 'entitree-flex';
import { ConnectionLineType, Edge, MarkerType, Node, Position } from 'reactflow';
import { Membership } from 'types';

const defaultWidth = 470;
const defaultHeight = 300;

const { Top, Bottom } = Position;

const updateNodeHeights = (tree: Record<string, MapNode>) => {
  Object.keys(tree).forEach((key) => {
    const node = tree[key];
    let height = defaultHeight;
    if (node.meta.loadedHeight && node.meta.contentExpanded) {
      height = node.meta.loadedHeight;
    } else if (node.type === 'workspace') {
      height = DEFAULT_WORKSPACE_HEIGHT;
    }
    tree[key] = { ...node, height };
  });
  return tree;
};

export const layoutElements = (
  tree: Record<string | number, MapNode>,
  addReportsToParent: (nodeId: string, reports: Membership[]) => void,
  toggleReports: (nodeId: string, expanded: boolean) => void,
  rootId: string,
  saveContentExpanded?: (nodeId: string, height: number, contentExpanded: boolean) => void,
) => {
  const modifiedTree = updateNodeHeights(tree);
  const { nodes: entitreeNodes, rels: entitreeEdges } = layoutFromMap(rootId, modifiedTree, {
    ...entitreeSettings,
    orientation: 'vertical',
    nodeWidth: defaultWidth,
    nodeHeight: defaultHeight,
  });

  const nodes: Node[] = [],
    edges: Edge[] = [];

  entitreeEdges.forEach((edge) => {
    edges.push({
      id: `e-${edge.source.id}-${edge.target.id}`,
      source: edge.source.id,
      target: edge.target.id,
      type: ConnectionLineType.SmoothStep,
      sourceHandle: Bottom,
      targetHandle: Top,
      markerEnd: {
        type: MarkerType.ArrowClosed,
        width: 25,
        height: 25,
      },
    });
  });

  entitreeNodes.forEach((node) => {
    const newNode: any = {
      id: node.id,
      type: node.type ?? 'default',
      position: { x: node.x, y: node.y },
      data: { label: node.name, addReportsToParent, toggleReports, saveContentExpanded, ...node },
      width: node.width,
      height: node.height,
      sourcePosition: Bottom,
      targetPosition: Top,
    };
    nodes.push(newNode);
  });

  return { nodes, edges };
};
